type QueryParams = {
    [key: string]: string | number;
};

const DEFAULT_QUERY_PARAMS: QueryParams = {
    filter: 'all',
    folderId: 0,
    page: 1,
    pageSize: 48,
    search: '',
    sort: '-tsLastMessageSent',
};

export const normalizeQuery = (
    query: QueryParams = {},
    defaults: typeof DEFAULT_QUERY_PARAMS = DEFAULT_QUERY_PARAMS
) => {
    const newQuery = { ...query };
    Object.keys(query).forEach((prop) => {
        if (`${query[prop]}` === `${defaults[prop]}` || defaults[prop] === undefined) {
            delete newQuery[prop];
        } else if (typeof defaults[prop] === 'number') {
            newQuery[prop] = Number(query[prop]);
        }
    });
    return newQuery;
};
